import React from 'react';
import InstructionsStep from '../steps/InstructionsStep';
import ReviewStep from '../steps/ReviewStep';
import SubmissionStep from '../steps/SubmissionStep';
import PaymentStep from '../steps/PaymentStep';
import RecordStep from '../steps/RecordStep';

const VatStepContent = ({ currentStep, stepProps }) => {
    const StepEnum = {
        INSTRUCTIONS: 'instructions',
        REVIEW: 'review',
        SUBMISSION: 'submission',
        PAYMENT: 'payment',
        RECORD: 'record'
    };

    const renderCurrentStep = () => {
        switch (currentStep) {
            case StepEnum.INSTRUCTIONS:
                return <InstructionsStep {...stepProps} />;
            case StepEnum.REVIEW:
                return <ReviewStep {...stepProps} />;
            case StepEnum.SUBMISSION:
                return <SubmissionStep {...stepProps} />;
            case StepEnum.PAYMENT:
                return <PaymentStep {...stepProps} />;
            case StepEnum.RECORD:
                return <RecordStep {...stepProps} />;
            default:
                return <InstructionsStep {...stepProps} />;
        }
    };

    return (
        <>
            <style>{`
                .vat-step-content-container {
                    background: white;
                    border-radius: 12px;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    border: 1px solid #e5e7eb;
                    overflow: hidden;
                    margin-bottom: 2rem;
                }
                
                .step-container {
                    padding: 2rem;
                }
                
                .step-header {
                    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                    margin: -2rem -2rem 2rem -2rem;
                    padding: 2rem;
                    border-bottom: 1px solid #e5e7eb;
                }
                
                .step-content {
                    margin-bottom: 2rem;
                }
                
                .step-actions {
                    border-top: 1px solid #f1f5f9;
                    padding-top: 1.5rem;
                    margin-top: 2rem;
                }
                
                /* Button styling for consistency */
                .step-container .btn {
                    border-radius: 8px;
                    font-weight: 500;
                    transition: all 0.2s ease;
                }
                
                .step-container .btn:hover:not(:disabled) {
                    transform: translateY(-1px);
                }
                
                .step-container .btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                    transform: none;
                }
                
                /* Alert styling */
                .step-container .alert {
                    border-radius: 8px;
                    border: none;
                    margin-bottom: 1.5rem;
                }
                
                /* Background for download section */
                .step-container .bg-light {
                    background-color: #f8fafc !important;
                    border-radius: 8px;
                }
                
                /* Mobile responsive */
                @media (max-width: 768px) {
                    .step-container {
                        padding: 1.5rem;
                    }
                    
                    .step-header {
                        margin: -1.5rem -1.5rem 1.5rem -1.5rem;
                        padding: 1.5rem;
                    }
                    
                    .step-actions .d-flex {
                        flex-direction: column;
                        gap: 1rem;
                    }
                    
                    .step-actions .d-flex .ms-auto {
                        margin-left: 0 !important;
                    }
                    
                    .step-actions .d-flex.gap-2 {
                        flex-direction: column;
                        gap: 0.5rem;
                    }
                }
            `}</style>

            <div className="vat-step-content-container">
                {renderCurrentStep()}
            </div>
        </>
    );
};

export default VatStepContent;